import { render, staticRenderFns } from "./Ipv4Input.vue?vue&type=template&id=12b00115&"
import script from "./Ipv4Input.vue?vue&type=script&lang=js&"
export * from "./Ipv4Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports